import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { CheckCircleRounded, Send } from "@material-ui/icons";
import { CheckCircle } from "@material-ui/icons/";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import {
  addHours,
  addMinutes,
  getHours,
  getMinutes,
  startOfDay,
} from "date-fns";
import MaterialTable from "material-table";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { RiFileExcel2Line } from "react-icons/ri";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useFormCombos } from "../../../hooks/useFormCombos";
import { useMeeting } from "../../../hooks/useMeeting";
import { useSendEmail } from "../../../hooks/useSendEmail";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import {
  addAgenda,
  cancelMeetingAgendaById,
  generateExcelDocument,
} from "../../../services/meeting.service";
import ConfirmScheduleModal from "../../Common/ConfirmScheduleModal";
import DialogCustom from "../../Common/DialogCustom";
import ToastMessage from "../../Common/ToastMessage";
import BatchSlotConfirmModal from "../../BatchSlotConfirmModal";
import FormSendMeetingInvite from "../../FormSendMeetingInvite/FormSendInvite";
import { getCurrencySymbol } from "../utils";
import { checkAccess } from "../utils/index";
import ModalBase from "../utils/ModalBase";
import { SlotLink } from "./styles";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  paper: {
    padding: 40,
    marginBottom: 40,
  },
  confirmScheduleText: {
    ...theme.typography.subtitle2,
    color: "#fff",
    marginLeft: 8,
    fontSize: 16,
    fontWeight: "bold",
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20,
  },
  cancelIcon: {
    color: theme.palette.error.main,
  },
  iconText: {
    ...theme.typography.subtitle1,
    cursor: "pointer",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    ...theme.typography.subtitle1,
    border: "2px solid",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  generateExcelButton: {
    ...theme.typography.subtitle1,
    border: "2px solid",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    padding: "8px",
  },
  spacer: {
    marginBottom: 20,
  },
  meetingInfo: {
    color: "red",
    fontWeight: "bold",
    marginBottom: "8px",
  },
}));

const FormSlot = ({ i18n, match, history, actionShowSpinner }) => {
  const { t } = useTranslation();

  const { getMeetingInfoById, meetingInfo, getMeetingTemplateAgenda } =
    useMeeting({
      spinner: actionShowSpinner,
    });
  const { getTypeSlot, typeSlot } = useFormCombos();

  const { userAccess } = useAuth();
  const { getTemplateslot } = useSendEmail({
    spinner: actionShowSpinner,
  });

  const [openModalSendEmail, setModalSendEmail] = useState(false);
  const [slot, setSlot] = useState({});
  const classes = useStyles();
  const [disable] = useState(meetingInfo.status === "O");
  const {
    params: { id },
  } = match;

  const [toastMessage, setToastMessage] = useState({
    message: "Essa ordenação não está disponível.",
    type: "error",
    open: false,
  });
  const [formattedSlots, setFormattedSlots] = useState([]);
  const [template, setTemplate] = useState([]);
  const [open, setOpen] = useState(false);

  const [canOrganizeSchedule, setCanOrganizeSchedule] = useState(false);
  const [canCancelMeet, setCanCancelMeet] = useState(false);
  const [canConfirmSchedule, setCanConfirmSchedule] = useState(false);
  const [schedulePersisted, setSchedulePersisted] = useState(true);
  const [meetIsUnavalableToEdit, setMeetIsUnavalableToEdit] = useState(false);
  const [confirmScheduleModalOpened, setConfirmScheduleModalOpened] =
    useState(false);
  const [emailBody, setEmailBody] = useState("");
  const [meetingData, setMeetingData] = useState(meetingInfo);
  const [selectedSlotIds, setSelectedSlotIds] = useState([]);
  const [openBatchConfirmModal, setOpenBatchConfirmModal] = useState(false);

  const confirmableSlots = useMemo(() => {
    return (formattedSlots || []).filter(
      (slot) =>
        slot.statusSlot.trim() === "A" || slot.statusSlot.trim() === "V"
    );
  }, [formattedSlots]);

  const handleToggleSlot = (slotId) => {
    setSelectedSlotIds((prev) => {
      if (prev.includes(slotId)) {
        return prev.filter((id) => id !== slotId);
      }
      return [...prev, slotId];
    });
  };

  const handleToggleAllSlots = () => {
    if (selectedSlotIds.length === confirmableSlots.length) {
      setSelectedSlotIds([]);
    } else {
      setSelectedSlotIds(confirmableSlots.map((slot) => slot.id));
    }
  };

  const handleBatchConfirmSuccess = (receipts) => {
    const newFormattedSlots = formattedSlots.map((slot) => {
      if (selectedSlotIds.includes(slot.id)) {
        return {
          ...slot,
          statusSlot: "P",
          slotConfirmationRecipients: receipts,
        };
      }
      return slot;
    });

    setFormattedSlots(newFormattedSlots);
    setSelectedSlotIds([]);
    setOpenBatchConfirmModal(false);
    setShowConfirmSlotSuccesMessage(true);
    setTimeout(() => setShowConfirmSlotSuccesMessage(false), 4000);
  };

  const isAllSlotsSelected =
    confirmableSlots.length > 0 &&
    selectedSlotIds.length === confirmableSlots.length;
  const isSlotsIndeterminate =
    selectedSlotIds.length > 0 &&
    selectedSlotIds.length < confirmableSlots.length;

  const columns = [
    ...(!meetingInfo.roundRobin
      ? [
          {
            title: (
              <Checkbox
                checked={isAllSlotsSelected}
                indeterminate={isSlotsIndeterminate}
                onChange={handleToggleAllSlots}
                disabled={meetIsUnavalableToEdit || confirmableSlots.length === 0}
                style={{ padding: 0 }}
              />
            ),
            field: "batchSelect",
            render: (row) => {
              const isConfirmable =
                row.statusSlot.trim() === "A" || row.statusSlot.trim() === "V";
              if (!isConfirmable) return null;
              return (
                <Checkbox
                  checked={selectedSlotIds.includes(row.id)}
                  onChange={() => handleToggleSlot(row.id)}
                  disabled={meetIsUnavalableToEdit}
                  style={{ padding: 0 }}
                />
              );
            },
            editable: "never",
            cellStyle: {
              width: 48,
              maxWidth: 48,
              paddingLeft: 8,
              paddingRight: 0,
            },
            headerStyle: {
              width: 48,
              maxWidth: 48,
              paddingLeft: 8,
              paddingRight: 0,
            },
          },
        ]
      : []),
    ...(!meetingInfo.roundRobin
      ? [
          {
            title: "",
            field: "action",
            render: (row) => (
              <CheckCircle
                onClick={
                  row.statusSlot.trim() === "P" ||
                  row.statusSlot.trim() == "F" ||
                  row.statusSlot.trim() == "D" ||
                  row.statusSlot.trim() == "C" ||
                  meetIsUnavalableToEdit
                    ? () => {
                        return;
                      }
                    : () => {
                        handleModal(row);
                      }
                }
                style={{
                  cursor:
                    row.statusSlot.trim() === "P" ||
                    row.statusSlot.trim() == "F" ||
                    row.statusSlot.trim() === "C"
                      ? "default"
                      : "pointer",
                  color:
                    row.statusSlot.trim() === "P" ||
                    row.statusSlot.trim() === "F" ||
                    row.statusSlot.trim() === "C"
                      ? "green"
                      : "grey",
                }}
              />
            ),
            editable: "never",
          },
        ]
      : []),
    ...(!meetingInfo.roundRobin
      ? [
          {
            title: "#",
            field: "order",
            editable: meetIsUnavalableToEdit ? "never" : "always",
            cellStyle: {
              minWidth: "120px",
            },
          },
        ]
      : []),
    ...(!meetingInfo.roundRobin
      ? [
          {
            title: "INÍCIO",
            field: "meetStartTime",
            render: (row) => `${row.meetStartTime}`,
            editable: "never",
            cellStyle: {
              backgroundColor: "#ccc",
              color: "#FFF",
              minWidth: "80px",
            },
          },
        ]
      : []),
    ...(!meetingInfo.roundRobin
      ? [
          {
            title: "FIM",
            field: "meetEndTime",
            render: (row) => `${row.meetEndTime}`,
            editable: "never",
            cellStyle: {
              backgroundColor: "#ccc",
              color: "#FFF",
              minWidth: "80px",
            },
          },
        ]
      : []),
    ...(!meetingInfo.roundRobin
      ? [
          {
            title: "DURAÇÃO (HH:MM)",
            field: "duration",
            editable: meetIsUnavalableToEdit ? "never" : "always",
            cellStyle: {
              width: 20,
              maxWidth: 20,
            },
            headerStyle: {
              width: 20,
              maxWidth: 20,
            },
          },
        ]
      : []),
    {
      title: `${t("slots.presenter").toUpperCase()}: `,
      field: "hosts",
      editable: "never",
      render: (row) => {
        return row.hosts.length > 1
          ? row.hosts.map((host) => host.userName).join(" | ")
          : row.presenter;
      },
    },
    {
      title: `${t("meeting.type").toUpperCase()}: `,
      field: "slotType",
      render: (row) => `${t(`slots.slotType.${row.slotType}`)}`,
      editable: "never",
    },
    {
      title: `${t("forms.themeName").toUpperCase()}: `,
      field: "name",
      editable: "never",
      cellStyle: {
        minWidth: "200px",
      },
    },
    {
      title: `${t("slots.objective").toUpperCase()}: `,
      field: "objective",
      editable: "never",
      cellStyle: {
        minWidth: "200px",
      },
    },
    {
      title: `${t("slots.companies").toUpperCase()}: `,
      field: "companies",
      editable: "never",
      cellStyle: {
        minWidth: "200px",
      },
      render: (row) => row.companies.map((cp) => cp.companyName).join(", "),
    },
    {
      title: `${t("slots.modality").toUpperCase()}: `,
      field: "modality",
      editable: "never",
      render: (row) =>
        `${row.modalities.map((m) => `${m.modalityName}`).join(", ")}`,
    },
    {
      title: `${t("slots.budget.title").toUpperCase()}: `,
      field: "budgeted",
      editable: "never",
    },
    {
      title: `${t("budgetedValue").toUpperCase()}: `,
      field: "budgetedValue",
      editable: "never",
      render: (row) =>
        row.budgetedValue
          ? `${getCurrencySymbol(row.currency)}${row.budgetedValue}`
          : "",
    },
    {
      title: `${t("multiannualBudgetAmount").toUpperCase()}: `,
      field: "multiannualBudgetAmount",
      editable: "never",
      render: (row) =>
        row.multiannualBudgetAmount
          ? `${getCurrencySymbol(row.currency)}${row.multiannualBudgetAmount}`
          : "",
    },
    {
      title: `${t("amountNotBudgetedYear").toUpperCase()}: `,
      field: "amountNotBudgetedYear",
      editable: "never",
      render: (row) =>
        row.amountNotBudgetedYear
          ? `${getCurrencySymbol(row.currency)}${row.amountNotBudgetedYear}`
          : "",
    },
    {
      title: `${t("requestedValue").toUpperCase()}: `,
      field: "requestedValue",
      editable: "never",
      render: (row) =>
        row.requestedValue
          ? `${getCurrencySymbol(row.currency)}${row.requestedValue}`
          : "",
    },
    {
      title: `${t("value").toUpperCase()}: `,
      field: "value",
      editable: "never",
      render: (row) =>
        row.value ? `${getCurrencySymbol(row.currency)}${row.value}` : "",
    },
    {
      title: `${t("additive").toUpperCase()}: `,
      field: "additive",
      editable: "never",
      render: (row) =>
        row.additive ? `${getCurrencySymbol(row.currency)}${row.additive}` : "",
    },
    {
      title: t("sponsor").toUpperCase(),
      field: "sponsor",
      editable: "never",
    },
    {
      title: `${t("slots.finalElevation").toUpperCase()}: `,
      field: "finalAuthority",
      editable: "never",
    },
  ];

  const scheduleDuration = useMemo(() => {
    let formattedHour = startOfDay(new Date());

    formattedSlots?.forEach((slot) => {
      formattedHour = addMinutes(
        addHours(formattedHour, Number(slot?.duration?.split(":")[0])),
        Number(slot?.duration?.split(":")[1])
      );
    });

    return `${getHours(formattedHour) < 10 ? "0" : ""}${getHours(
      formattedHour
    )}:${getMinutes(formattedHour) < 10 ? "0" : ""}${getMinutes(
      formattedHour
    )}`;
  }, [formattedSlots]);

  useEffect(() => {
    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "showScheduleMeet");
      const hasAccessToOrganizeSchedule = checkAccess(
        userAccess,
        "organizeScheduleMeet"
      );
      const hasAccessToCancelMeet = checkAccess(userAccess, "cancelMeet");
      const hasAccessToConfirmSchedule = checkAccess(
        userAccess,
        "confirmScheduleMeet"
      );

      setCanConfirmSchedule(hasAccessToConfirmSchedule);
      setCanOrganizeSchedule(hasAccessToOrganizeSchedule);
      setCanCancelMeet(hasAccessToCancelMeet);

      if (!hasAccess) {
        history.push("/");
      }

      if (id && i18n) {
        getMeetingInfoById(i18n.language, id);
        getTypeSlot(i18n.language);
      }
    }
  }, [i18n, id, userAccess]);

  useEffect(() => {
    actionShowSpinner(true);

    setMeetingData(meetingInfo);

    let requestTemplate = {
      committeName: meetingInfo.committeName,
      MeetDate: meetingInfo.meetDate,
      meetId: meetingInfo.meetId,
    };

    getMeetingTemplateAgenda(requestTemplate).then((bodyTemplate) => {
      setEmailBody(bodyTemplate.replaceAll("\r\n", "<br/>"));
    });

    setMeetIsUnavalableToEdit(
      meetingInfo.status === "CC" || meetingInfo.status === "UD"
    );
    setCanConfirmSchedule((oldValue) =>
      oldValue
        ? meetingInfo.status !== "CC" && meetingInfo.status !== "UD"
        : oldValue
    );

    setOnlineMeet(meetingInfo.onlineMeetingProvider);

    const slots = meetingInfo.roundRobin
      ? meetingInfo?.slots?.sort((a, b) => Number(a.order) - Number(b.order))
      : meetingInfo?.slots
          ?.filter(
            (slot) =>
              !slot.extrSlot &&
              (slot.statusSlot.trim() === "P" ||
                slot.statusSlot.trim() === "A" ||
                slot.statusSlot.trim() === "F" ||
                slot.statusSlot.trim() === "V" ||
                slot.statusSlot.trim() === "D" ||
                slot.statusSlot.trim() === "C")
          )
          ?.sort((a, b) => Number(a.order) - Number(b.order));

    let lastEndMeetTime;

    const initialSlots = slots?.map((slot, index) => {
      const date = new Date();

      const duration = slot.duration.slice(0, -3);

      let meetStartTimesTamp;

      if (index === 0) {
        meetStartTimesTamp = addMinutes(
          addHours(
            startOfDay(date),
            Number(meetingInfo.meetStartTime?.split(":")[0])
          ),
          Number(meetingInfo.meetStartTime?.split(":")[1])
        );
      } else {
        meetStartTimesTamp = addMinutes(
          addHours(startOfDay(date), Number(lastEndMeetTime.split(":")[0])),
          Number(lastEndMeetTime.split(":")[1])
        );
      }

      const meetEndTime = addMinutes(
        addHours(meetStartTimesTamp, Number(duration.split(":")[0])),
        Number(duration.split(":")[1])
      );

      lastEndMeetTime = `${getHours(meetEndTime)}:${getMinutes(meetEndTime)}`;
      const currentPath = history.location.pathname;

      return {
        ...slot,
        name: (
          <SlotLink
            onClick={() => {
              history.push({
                pathname: `/slot/edit/${slot.id}`,
                state: { editSlotCommittee: false, returnUrl: currentPath },
              });
            }}
          >
            {slot.name}
          </SlotLink>
        ),
        duration,
        meetStartTime: `${
          getHours(meetStartTimesTamp) < 10 ? "0" : ""
        }${getHours(meetStartTimesTamp)}:${
          getMinutes(meetStartTimesTamp) < 10 ? "0" : ""
        }${getMinutes(meetStartTimesTamp)}`,
        meetEndTime: `${getHours(meetEndTime) < 10 ? "0" : ""}${getHours(
          meetEndTime
        )}:${getMinutes(meetEndTime) < 10 ? "0" : ""}${getMinutes(
          meetEndTime
        )}`,
      };
    });

    const someSlotDifferentOfDb = initialSlots?.some((slot) => {
      const persistedSlot = meetingInfo?.slots?.find((s) => s.id === slot.id);

      if (
        !persistedSlot ||
        !persistedSlot.meetStartTime ||
        !persistedSlot.meetEndTime
      ) {
        return true;
      }

      const [persistedSlotStartHours, persistedSlotStartMinutes] =
        persistedSlot.meetStartTime?.split(":") || [];
      const [persistedSlotEndHours, persistedSlotEndMinutes] =
        persistedSlot.meetEndTime?.split(":") || [];

      const persistedSlotStartTime = `${persistedSlotStartHours}:${persistedSlotStartMinutes}`;
      const persistedSlotEndTime = `${persistedSlotEndHours}:${persistedSlotEndMinutes}`;

      return (
        persistedSlotStartTime !== slot.meetStartTime ||
        persistedSlotEndTime !== slot.meetEndTime
      );
    });

    if (someSlotDifferentOfDb) {
      setSchedulePersisted(false);
    }

    setFormattedSlots(initialSlots);
  }, [meetingInfo, actionShowSpinner]);

  const handleClickOpen = () => {
    if (disable) return;
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeDisable = async () => {
    setOpen(false);

    let request = {
      meetId: meetingInfo.meetId,
    };

    let response = await cancelMeetingAgendaById(i18n.language, request);

    if (response?.error?.length > 0 || !response) {
      setToastMessage({
        message: t("error"),
        type: "error",
        open: true,
      });

      return;
    }

    history.push({
      pathname: "/meetings",
      state: { successCancelMeet: true },
    });
  };

  async function handleModal(slot) {
    setSlot(slot);
    const formattedPresenters =
      slot?.hosts.length > 0
        ? slot?.hosts?.map((host) => host?.userName).join("| ")
        : "";

    let requestTemplate = {
      committeName: meetingInfo.committeName,
      presenters: formattedPresenters,
      objective: slot.objective,
      theme: slot.name.props.children,
      slotCommitteeId: slot.slotCommitteeId,
      slotDate: meetingInfo.meetDate,
    };

    let templateTemp = await getTemplateslot(requestTemplate);

    setTemplate(templateTemp.data.replaceAll("\r\n", "<br/>"));
    setModalSendEmail(true);
  }

  const handleSave = async () => {
    actionShowSpinner(true);

    let requestCreate = {
      MeetId: meetingInfo.meetId,
      MeetTime: meetingInfo.meetTime,
      SlotMeetTime: scheduleDuration,
      Slots: formattedSlots.map((slot) => ({
        ...slot,
        name: slot.name.props.children,
      })),
    };

    const response = await addAgenda(requestCreate);

    actionShowSpinner(false);

    if (response.error.length > 0) {
      setToastMessage({
        message:
          response.error.length > 0
            ? response.error
            : "Ocorreu um erro ao salvar a agenda",
        type: "error",
        open: true,
      });

      return;
    }

    history.push({
      pathname: "/meetings",
      state: { successCreateSchedule: true },
    });
  };

  const [showConfirmSlotSuccesMessage, setShowConfirmSlotSuccesMessage] =
    useState(false);

  const handleConfirmSlot = (slot, newReceipts) => {
    const newFormattedSlots = formattedSlots.map((formattedSlot) => {
      if (formattedSlot.id === slot.id) {
        return {
          ...formattedSlot,
          statusSlot: "P",
          slotConfirmationRecipients: newReceipts,
        };
      }

      return formattedSlot;
    });

    setModalSendEmail(false);

    setShowConfirmSlotSuccesMessage(true);

    setFormattedSlots(newFormattedSlots);

    setTimeout(() => setShowConfirmSlotSuccesMessage(false), 4000);
  };

  const [onlineMeet, setOnlineMeet] = useState(false);

  const handleCloseScheduleModal = useCallback(() => {
    setConfirmScheduleModalOpened(false);
  }, []);

  const handleSuccessConfirmSchedule = useCallback((newEmails) => {
    setMeetingData((oldValue) => ({
      ...oldValue,
      meetConfirmationRecipients: newEmails,
    }));
  }, []);

  const handleGenerateExcelDocument = useCallback(async () => {
    actionShowSpinner(true);

    const response = await generateExcelDocument(meetingInfo.meetId);

    actionShowSpinner(false);

    if (response?.error?.length > 0 || !response) {
      setToastMessage({
        message: t("error"),
        type: "error",
        open: true,
      });

      return;
    }

    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      })
    );
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "agenda.xlsx");

    document.body.appendChild(link);

    link.click();
  }, [meetingInfo, actionShowSpinner]);

  return (
    <Grid container className={classes.root}>
      <ToastMessage
        message={toastMessage.message}
        type={toastMessage.type || "error"}
        open={toastMessage.open}
        close={() => setToastMessage({ ...toastMessage, open: false })}
      />

      <ModalBase
        open={confirmScheduleModalOpened}
        setOpen={setConfirmScheduleModalOpened}
        content={
          <ConfirmScheduleModal
            i18n={i18n}
            t={t}
            setModalStatus={(value) => setConfirmScheduleModalOpened(value)}
            handelCloseModal={handleCloseScheduleModal}
            bodyEmail={emailBody}
            openModalStatus={confirmScheduleModalOpened}
            meetingInfo={meetingData}
            formattedSlots={formattedSlots}
            onSucces={handleSuccessConfirmSchedule}
            setToastMessage={setToastMessage}
          />
        }
      />

      <ModalBase
        open={openModalSendEmail}
        setOpen={setModalSendEmail}
        content={
          <>
            <span
              style={{ float: "right", cursor: "pointer" }}
              onClick={() => {
                setModalSendEmail(!openModalSendEmail);
              }}
            >
              [X] Fechar
            </span>
            <span className={classes.titleModal}>Enviar Convite</span>
            <FormSendMeetingInvite
              bodyEmail={template}
              data={slot}
              meetingData={meetingInfo}
              typeFormSend={"Slot"}
              enableSendEmail={true}
              t={t}
              setModalSendEmail={setModalSendEmail}
              onSendEmail={(newReceipts) => {
                handleConfirmSlot(slot, newReceipts);
              }}
            />
          </>
        }
      />

      <ModalBase
        open={openBatchConfirmModal}
        setOpen={setOpenBatchConfirmModal}
        content={
          <BatchSlotConfirmModal
            slots={(formattedSlots || []).filter((slot) =>
              selectedSlotIds.includes(slot.id)
            )}
            meetingInfo={meetingInfo}
            onClose={() => setOpenBatchConfirmModal(false)}
            onConfirm={handleBatchConfirmSuccess}
            t={t}
          />
        }
      />

      <Grid container direction="row" spacing={3}>
        <Grid item lg={12} xs={12}>
          <Paper elevation={1} className={classes.paper}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                style={{ float: "right" }}
                control={
                  <Switch
                    id={disable}
                    checked={disable}
                    onChange={handleClickOpen}
                    name="cancel"
                    color="primary"
                    disabled={!canCancelMeet || meetIsUnavalableToEdit}
                  />
                }
                label={t("meeting.cancelSchedule")}
              />
            </div>
            <div>
              <DialogCustom
                open={open}
                handleClose={handleClose}
                handleChange={handleChangeDisable}
                title={t(`forms.dialog.alert`)}
                body={t("forms.dialog.textDeleteAgendaMetting")}
                confirmText={t(`forms.dialog.yes`)}
                cancelText={t(`forms.dialog.no`)}
                alert={true}
              />
              <Typography className={classes.title}>
                {t("meeting.meetingScheduleInfo")}
              </Typography>

              <Typography className={classes.meetingInfo}>
                {t("meeting.meetingInfo")}
              </Typography>
              <Grid container spacing={3}>
                <Grid item lg={6} xs={12}>
                  <TextField
                    name="committee"
                    id="committee"
                    value={meetingInfo.committeName || ""}
                    label={t("meeting.committee")}
                    fullWidth
                    required
                    autoComplete="nope"
                    disabled={true}
                  />
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    name="committee"
                    id="committee"
                    value={meetingInfo.secretaryName || ""}
                    label={t("meeting.secretary")}
                    fullWidth
                    required
                    autoComplete="nope"
                    disabled={true}
                  />
                </Grid>
                <Grid item lg={12} xs={12}>
                  <TextField
                    name="subject"
                    id="subject"
                    value={meetingInfo.subject || ""}
                    label={t("meeting.subject")}
                    fullWidth
                    required
                    autoComplete="nope"
                    disabled={true}
                  />
                </Grid>
                <Grid item lg={3} xs={6}>
                  <FormControlLabel
                    fullWidth
                    control={
                      <Checkbox
                        value={onlineMeet}
                        checked={onlineMeet}
                        // onChange={(event) => { setValue({ ...value, onlineMeet: !value.onlineMeet }) }}
                        name="onlineMeet"
                        id="onlineMeet"
                        color="primary"
                        disabled={true}
                      />
                    }
                    label={t("meeting.onlineMeet")}
                  />
                </Grid>
                {!onlineMeet && (
                  <Grid item lg={3} xs={12}>
                    <TextField
                      name="place"
                      id="place"
                      value={meetingInfo.locationName || ""}
                      label={t("meeting.place")}
                      fullWidth
                      required
                      autoComplete="nope"
                      disabled={true}
                    />
                  </Grid>
                )}
                <Grid item lg={6} xs={12}>
                  <TextField
                    name="place1"
                    id="place1"
                    value={meetingInfo.meetDate || ""}
                    label={t("meeting.meetingDate")}
                    fullWidth
                    required
                    autoComplete="nope"
                    disabled={true}
                  />
                </Grid>
                <Grid item lg={3} xs={6}>
                  <TextField
                    fullWidth
                    name="status"
                    value={meetingInfo.statusName || ""}
                    inputProps={{
                      id: "status",
                    }}
                    disabled={true}
                    label={t("meeting.status")}
                  />
                </Grid>

                {!meetingInfo.roundRobin && (
                  <>
                    <Grid item lg={3} xs={6}>
                      <TextField
                        fullWidth
                        name="startTime"
                        value={meetingInfo.meetStartTime || ""}
                        inputProps={{
                          id: "startTime",
                        }}
                        disabled={true}
                        label={t("meeting.startTime")}
                      />
                    </Grid>
                    <Grid item lg={3} xs={6}>
                      <TextField
                        fullWidth
                        name="endTime"
                        value={meetingInfo.meetEndTime || ""}
                        inputProps={{
                          id: "endTime",
                        }}
                        disabled={true}
                        label={t("meeting.endTime")}
                      />
                    </Grid>
                    <Grid item lg={3} xs={6}>
                      <TextField
                        fullWidth
                        name="meetingDuration"
                        value={meetingInfo.meetTime || ""}
                        inputProps={{
                          id: "meetingDuration",
                        }}
                        disabled={true}
                        label={t("meeting.meetingDuration")}
                      />
                    </Grid>
                  </>
                )}

                <Grid item lg={3} xs={6}>
                  <FormControlLabel
                    fullWidth
                    control={
                      <Checkbox
                        value={!!meetingInfo.roundRobin}
                        checked={!!meetingInfo.roundRobin}
                        disabled
                        name="roundRobin"
                        id="roundRobin"
                        color="primary"
                      />
                    }
                    label={t("meeting.roundRobin")}
                  />
                </Grid>

                <Grid item lg={12} xs={12}>
                  <TextField
                    name="comments"
                    id="comments"
                    value={meetingInfo.observation || ""}
                    label={t("meeting.comments")}
                    fullWidth
                    required
                    autoComplete="nope"
                    disabled={true}
                  />
                </Grid>
                <Grid container item direction="row">
                  <Grid item lg={12} xs={12}>
                    <Grid item md={12} lg={12} style={{ maxWidth: "100%" }}>
                      <MaterialTable
                        title=""
                        columns={columns}
                        data={formattedSlots?.sort(
                          (a, b) => Number(a.order) - Number(b.order)
                        )}
                        icons={tableIcons}
                        cellEditable={{
                          onCellEditApproved: (
                            newValue,
                            oldValue,
                            rowData,
                            columnDef
                          ) => {
                            return new Promise((resolve, reject) => {
                              if (columnDef.field == "order") {
                                const slotWithSameOrder = formattedSlots.find(
                                  (slot) =>
                                    Number(slot.order) === Number(newValue)
                                );
                                const slotWithSameOrderIndex =
                                  formattedSlots.findIndex(
                                    (slot) =>
                                      Number(slot.order) === Number(newValue)
                                  );
                                const slotOrderIndex = formattedSlots.findIndex(
                                  (slot) =>
                                    Number(slot.order) === Number(oldValue)
                                );

                                const lastOrder = formattedSlots?.sort(
                                  (a, b) => Number(a.order) - Number(b.order)
                                )[
                                  formattedSlots?.sort(
                                    (a, b) => Number(a.order) - Number(b.order)
                                  ).length - 1
                                ].order;

                                if (newValue > lastOrder) {
                                  setToastMessage({
                                    message:
                                      "Essa ordenação não está disponível.",
                                    type: "error",
                                    open: true,
                                  });

                                  rowData.order = Number(oldValue);
                                } else {
                                  rowData.order = Number(newValue);

                                  const reorderList = formattedSlots
                                    .map((slot, index) => {
                                      if (slot.id === slotWithSameOrder.id) {
                                        return {
                                          ...slotWithSameOrder,
                                          order: Number(oldValue),
                                          statusSlot: "A",
                                        };
                                      }

                                      if (slot.id === rowData.id) {
                                        return {
                                          ...slot,
                                          order: Number(newValue),
                                          statusSlot: "A",
                                          meetStartTime:
                                            slotWithSameOrder.meetStartTime,
                                        };
                                      } else if (
                                        index > slotOrderIndex ||
                                        index > slotWithSameOrderIndex
                                      ) {
                                        return {
                                          ...slot,
                                          statusSlot: "A",
                                        };
                                      } else {
                                        return slot;
                                      }
                                    })
                                    ?.sort(
                                      (a, b) =>
                                        Number(a.order) - Number(b.order)
                                    );

                                  let lastEndMeetTime = "";

                                  const formattedList = reorderList.map(
                                    (slot, index) => {
                                      const date = new Date();

                                      const duration = slot.duration;

                                      let meetStartTimesTamp;

                                      if (index === 0) {
                                        meetStartTimesTamp = addMinutes(
                                          addHours(
                                            startOfDay(date),
                                            Number(
                                              meetingInfo.meetStartTime?.split(
                                                ":"
                                              )[0]
                                            )
                                          ),
                                          Number(
                                            meetingInfo.meetStartTime?.split(
                                              ":"
                                            )[1]
                                          )
                                        );
                                      } else {
                                        meetStartTimesTamp = addMinutes(
                                          addHours(
                                            startOfDay(date),
                                            Number(
                                              lastEndMeetTime.split(":")[0]
                                            )
                                          ),
                                          Number(lastEndMeetTime.split(":")[1])
                                        );
                                      }

                                      const meetEndTime = addMinutes(
                                        addHours(
                                          meetStartTimesTamp,
                                          Number(duration.split(":")[0])
                                        ),
                                        Number(duration.split(":")[1])
                                      );

                                      lastEndMeetTime = `${getHours(
                                        meetEndTime
                                      )}:${getMinutes(meetEndTime)}`;

                                      return {
                                        ...slot,
                                        duration,
                                        meetStartTime: `${
                                          getHours(meetStartTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getHours(meetStartTimesTamp)}:${
                                          getMinutes(meetStartTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getMinutes(meetStartTimesTamp)}`,
                                        meetEndTime: `${
                                          getHours(meetEndTime) < 10 ? "0" : ""
                                        }${getHours(meetEndTime)}:${
                                          getMinutes(meetEndTime) < 10
                                            ? "0"
                                            : ""
                                        }${getMinutes(meetEndTime)}`,
                                      };
                                    }
                                  );

                                  setSchedulePersisted(false);
                                  setFormattedSlots(formattedList);
                                }
                              } else if (columnDef.field == "duration") {
                                const isValidDuration = String(newValue).match(
                                  /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/
                                );

                                if (!isValidDuration) {
                                  setToastMessage({
                                    message: t(
                                      "menu.meeting.info.durationFormatError"
                                    ),
                                    type: "error",
                                    open: true,
                                  });

                                  rowData.duration = oldValue;
                                  setTimeout(resolve, 1000);

                                  return;
                                }

                                const changedSlotIndex =
                                  formattedSlots.findIndex(
                                    (slot) => slot.id === rowData.id
                                  );

                                const date = new Date();

                                const newList = formattedSlots.map(
                                  (slot, index) => {
                                    if (index > changedSlotIndex) {
                                      const startTimesTampWithHours = addHours(
                                        startOfDay(date),
                                        Number(
                                          slot?.meetStartTime?.split(":")[0]
                                        )
                                      );

                                      const currentStartTimesTamp = addMinutes(
                                        startTimesTampWithHours,
                                        Number(
                                          slot?.meetStartTime?.split(":")[1]
                                        )
                                      );

                                      const startHoursDiff =
                                        Number(newValue.split(":")[0]) -
                                        Number(oldValue.split(":")[0]);
                                      const startMinutesDiff =
                                        Number(newValue.split(":")[1]) -
                                        Number(oldValue.split(":")[1]);

                                      const startTimesTampHoursUpdate =
                                        addHours(
                                          currentStartTimesTamp,
                                          startHoursDiff
                                        );
                                      const newStartTimesTamp = addMinutes(
                                        startTimesTampHoursUpdate,
                                        startMinutesDiff
                                      );

                                      const endTimesTampWithHours = addHours(
                                        startOfDay(date),
                                        Number(slot?.meetEndTime?.split(":")[0])
                                      );

                                      const currentEndTimesTamp = addMinutes(
                                        endTimesTampWithHours,
                                        Number(slot?.meetEndTime?.split(":")[1])
                                      );

                                      const endHoursDiff =
                                        Number(newValue.split(":")[0]) -
                                        Number(oldValue.split(":")[0]);
                                      const endMinutesDiff =
                                        Number(newValue.split(":")[1]) -
                                        Number(oldValue.split(":")[1]);

                                      const endTimesTampHoursUpdate = addHours(
                                        currentEndTimesTamp,
                                        endHoursDiff
                                      );
                                      const newEndTimesTamp = addMinutes(
                                        endTimesTampHoursUpdate,
                                        endMinutesDiff
                                      );

                                      return {
                                        ...slot,
                                        meetEndTime: `${
                                          getHours(newEndTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getHours(newEndTimesTamp)}:${
                                          getMinutes(newEndTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getMinutes(newEndTimesTamp)}`,
                                        meetStartTime: `${
                                          getHours(newStartTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getHours(newStartTimesTamp)}:${
                                          getMinutes(newStartTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getMinutes(newStartTimesTamp)}`,
                                        statusSlot: "A",
                                      };
                                    } else if (slot.id === rowData.id) {
                                      const startTimesTampWithHours = addHours(
                                        startOfDay(date),
                                        Number(
                                          slot?.meetStartTime?.split(":")[0]
                                        )
                                      );

                                      const currentStartTimesTamp = addMinutes(
                                        startTimesTampWithHours,
                                        Number(
                                          slot?.meetStartTime?.split(":")[1]
                                        )
                                      );

                                      const newEndTimesTamp = addMinutes(
                                        addHours(
                                          currentStartTimesTamp,
                                          Number(newValue.split(":")[0])
                                        ),
                                        Number(newValue.split(":")[1])
                                      );

                                      return {
                                        ...slot,
                                        meetEndTime: `${
                                          getHours(newEndTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getHours(newEndTimesTamp)}:${
                                          getMinutes(newEndTimesTamp) < 10
                                            ? "0"
                                            : ""
                                        }${getMinutes(newEndTimesTamp)}`,
                                        duration: newValue,
                                        statusSlot: "A",
                                      };
                                    } else {
                                      return slot;
                                    }
                                  }
                                );

                                setSchedulePersisted(false);
                                setFormattedSlots(
                                  newList?.sort(
                                    (a, b) => Number(a.order) - Number(b.order)
                                  )
                                );
                              }

                              setTimeout(resolve, 1000);
                            });
                          },
                        }}
                        options={{
                          search: false,
                          headerStyle: {
                            backgroundColor: "#031795",
                            color: "#FFF",
                          },
                          actionsColumnIndex: -1,
                        }}
                        actions={[]}
                        localization={{
                          header: {
                            actions: "",
                          },
                        }}
                      />

                      {showConfirmSlotSuccesMessage && (
                        <Grid
                          style={{
                            width: "100%",
                            backgroundColor: "green",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "6px",
                          }}
                          container
                          item
                          direction="row"
                          alignItems="center"
                          justify="center"
                          className={classes.success}
                        >
                          <Grid item>
                            <CheckCircleRounded className={classes.icon} />
                          </Grid>
                          <Grid item style={{ marginLeft: "4px" }}>
                            <Typography className={classes.label}>
                              {t("slots.confirmSlotSucces")}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  direction="row"
                  style={{
                    flex: 1,
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                  }}
                >
                  <Tooltip aria-label="teste" title="Gerar Excel">
                    <Button
                      variant="outlined"
                      className={classes.generateExcelButton}
                      onClick={handleGenerateExcelDocument}
                    >
                      <RiFileExcel2Line />
                    </Button>
                  </Tooltip>

                  <span className="span" style={{ color: "#465eb6" }}>
                    <strong>DURAÇÃO DA AGENDA</strong> - {scheduleDuration}{" "}
                  </span>
                </Grid>
              </Grid>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <Grid container item direction="row" justify="center" spacing={2}>
        <Grid item>
          <Button
            variant="outlined"
            className={classes.buttonOutlined}
            onClick={() => history.push("/meetings")}
          >
            {t("cancel")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleSave}
            disabled={!canOrganizeSchedule || meetIsUnavalableToEdit}
          >
            {t("meeting.saveSchedule")}
          </Button>
        </Grid>
        {selectedSlotIds.length > 0 && (
          <Grid item>
            <Button
              variant="contained"
              className={classes.button}
              disabled={!canConfirmSchedule}
              onClick={() => {
                if (!schedulePersisted) {
                  setToastMessage({
                    message: t("meeting.cantConfirmScheduleNonPersisted"),
                    type: "error",
                    open: true,
                  });
                  return;
                }
                setOpenBatchConfirmModal(true);
              }}
            >
              <CheckCircle style={{ color: "#fff", marginRight: 8 }} />
              <Typography className={classes.confirmScheduleText}>
                {`Confirmar Selecionados (${selectedSlotIds.length})`}
              </Typography>
            </Button>
          </Grid>
        )}
        <Grid item>
          <Button
            variant="contained"
            className={classes.button}
            disabled={!canConfirmSchedule}
            onClick={() => {
              if (!schedulePersisted) {
                setToastMessage({
                  message: t("meeting.cantConfirmScheduleNonPersisted"),
                  type: "error",
                  open: true,
                });

                return;
              }

              setConfirmScheduleModalOpened(true);
            }}
          >
            <Send style={{ color: "#fff" }} />
            <Typography className={classes.confirmScheduleText}>
              {t("meeting.confirmAgenda")}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const withRouterFormSlot = withRouter(FormSlot);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const FormSlotConnect = connect(null, mapDispatchToProps)(withRouterFormSlot);

export default withTranslation()(FormSlotConnect);
